import React, { Fragment, useEffect, useState } from 'react'

function CurrencySymbol() {
    const flavour = process.env.REACT_APP_FLAVOUR

    const [currencySymbol, setCurrencySymbol] = useState("$")

    useEffect(() => {
        setCurrencySymbol(getCurrencySymbol())
    }, [])

    function getCurrencySymbol() {
        switch (flavour) {
            case "PH":
                return "Php"
            default:
                return "$"
        }
    }

    return (
        <Fragment>
            {currencySymbol}
        </Fragment>
    )
}

export default CurrencySymbol

